import GuidePostContainer from "../../GuidePageTemplate";
import GuidePostSideBar from "../../GuidePageTemplate/Sidebar";
import GuidePostMain from "../../GuidePageTemplate/Main";
import {
	GuidePageTemplateNavItem as GuidePostNavItem,
	GuidePageTemplateNavItemLink as GuidePostNavItemLink,
} from "../../GuidePageTemplate/Nav";

export {
	GuidePostSideBar,
	GuidePostContainer,
	GuidePostNavItem,
	GuidePostNavItemLink,
	GuidePostMain,
};
